import { Component, DoCheck, Input, inject } from '@angular/core';
import { AufnahmePunktDocument, bodenformString, wasserformString, bohrpunktNummerLabel, hatHumusForm, hatVegetationsformengruppe, humusformLabel, isB, isG, isM, roundToNumber } from '../../../data-model';
import { EvaluationService } from '../../evaluation.service';
import { ValidationService } from '../../validation.service';
import { DataService } from 'src/app/data.service';
import { AuthService } from 'src/app/auth.service';

@Component({
    standalone: false,
    selector: 'bp-bohrpunkt-kurzprotokoll',
    templateUrl: './bohrpunkt-kurzprotokoll.component.html',
    styleUrls: ['../hl-table.component.css'],

})
export class BohrpunktKurzprotokollComponent implements DoCheck {

  @Input() bp!: AufnahmePunktDocument;
  @Input() printView!: boolean;

	roundToNumber = roundToNumber;
	bohrpunktNummerLabel = bohrpunktNummerLabel
	humusformLabel = humusformLabel;
	hatHumusForm = hatHumusForm;
	hatVegetationsformengruppe = hatVegetationsformengruppe;
	wasserformString = wasserformString;
	aus = inject(AuthService);

  constructor(
    private ds: DataService,
    private es: EvaluationService,
    private vs: ValidationService,
  ) { }

  /** Prüft ob Kartierer/Datum angezeigt werden darf (nicht für Gäste und nicht-angemeldete) */
  canSeePersonalData(): boolean {
    return this.aus.isAuthenticated.getValue() && !this.aus.amI('gast');
  }

  ngDoCheck(): void {
    this.es.setContext(this.bp);
    this.vs.setContext(this.bp);
  }

  adresse(): string {
    const a = this.bp.header.adresse;
    return '${a.abteilung}${a.unterabteilung}${a.teilflaeche}';
  }

  hasGemarkung(): boolean {
    return !!this.bp.header.adresse.gemarkung || !!this.bp.header.adresse.flur || !!this.bp.header.adresse.flurstueck;
  }

  isB(): boolean {
    return isB(this.bp);
  }

  isG(): boolean {
    return isG(this.bp);
  }

  isM(): boolean {
    return isM(this.bp);
  }

  bodenformString(which: string) {
		return bodenformString(this.bp.header.bodenform, which);
  }

  qualityString(quality: number) {
    const e = this.ds.hardData.Qualitätsstufen.find((entry: any) => entry.id === quality);
    return e ? e.name : "unbekannt";
  }

  hauptbodenform = () => this.bodenformString('hbf');
  feinbodenform = () => this.bodenformString('fbf');
  mesoklimaSuffix = () => this.bp.extendedHeader?.mesoklima ? `-${this.bp.extendedHeader.mesoklima}` : '';
}
